import React from "react";
import Footer from "../../components/footer";
import Header from "../../components/header";
import { connect } from "react-redux";
import {editPaymentRule } from '../../services/admin/action';
import DeleteModel from '../common/Model/deleteModel';

class EditPaymentRules extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            email:"",
            access_token :  "",
            id : "" ,
            state : "" ,
            stateAbbreviation : "" ,
            isAllowedState : "" ,
            isPostageUpchargeAllowed : "" ,
            upChargeRate : "" ,
            isFedexOrMailAvailable : "" ,
            searchOrHandlingFee : "" ,
            isSearchFeeToPatientAsRequestor : "" ,
            maximumFee : "" ,	
            isSearchFeeOneToFive : "" ,
            isSearchFeeOneToTen : "" ,
            isSearchFeeOneToFourteen : "" ,
            isSearchFeeOneToTwenty : "" ,
            isSearchFeeOneToTwentyFive : "" ,
            oneThroughTwenty : "" ,
            oneThroughTen : "" ,
            oneThroughTwentyFive : "" ,
            oneThroughThirty : "" ,
            oneThroughFourty : "" ,
            oneThroughHundred : "" ,
            sixAndOver : "" ,
            elevenAndOver : "" ,
            elevenThroughTwenty : "" ,
            elevenThroughFourty : "" ,
            elevenThroughFifty : "" ,
            fourteenThroughTwentyFive : "" ,
            sixteenAndOver : "" ,
            twentyOneThroughFifty : "" ,
            twentyOneThroughSixty : "" ,
            twentyOneThroughHundred : "" ,
            twentySixThroughFifty : "" ,
            twentySixThroughHundred : "" ,
            twentySixThroughThreeFifty : "" ,
            twentySixAndOver : "" ,
            thirtyOneAndOver : "" ,
            fourtyOneAndOver : "" ,
            fiftyOneThroughHundred : "" ,
            fiftyOneAndOver : "" ,
            sixtyOneAndOver : "" ,
            hundredAndOneAndOver : "" ,
            threeFiftyOneAndOver : "" ,
            regardlessOfAllPages : "" ,
            openPopUp: false,
        }
    }

 

    componentDidMount(){

      if(this.props.profileDetails){
            let email = this.props.profileDetails.commonUser.email
            this.setState({
                  email
            })
      }

       let access_token =  this.props.loginDetails; 
       if(this.props.savedPaymentRule){
             let data = this.props.savedPaymentRule;
             let editValues = this.state;
       let id = data.id ? data.id : editValues.id ;
       let state = data.state ? data.state : editValues.state ;
       let stateAbbreviation = data.stateAbbreviation ? data.stateAbbreviation : editValues.stateAbbreviation ;
       let isAllowedState = data.isAllowedState ? data.isAllowedState : editValues.isAllowedState ;
       let isPostageUpchargeAllowed = data.isPostageUpchargeAllowed ? data.isPostageUpchargeAllowed : editValues.isPostageUpchargeAllowed ;
       let upChargeRate = data.upChargeRate ? data.upChargeRate : editValues.upChargeRate ;
       let isFedexOrMailAvailable = data.isFedexOrMailAvailable ? data.isFedexOrMailAvailable : editValues.isFedexOrMailAvailable ;
       let searchOrHandlingFee = data.searchOrHandlingFee ? data.searchOrHandlingFee : editValues.searchOrHandlingFee ;
       let isSearchFeeToPatientAsRequestor = data.isSearchFeeToPatientAsRequestor ? data.isSearchFeeToPatientAsRequestor : editValues.isSearchFeeToPatientAsRequestor ;
       let maximumFee = data.maximumFee ? data.maximumFee : editValues.maximumFee ;	
       let isSearchFeeOneToFive = data.isSearchFeeOneToFive ? data.isSearchFeeOneToFive : editValues.isSearchFeeOneToFive ;
       let isSearchFeeOneToTen = data.isSearchFeeOneToTen ? data.isSearchFeeOneToTen : editValues.isSearchFeeOneToTen ;
       let isSearchFeeOneToFourteen = data.isSearchFeeOneToFourteen ? data.isSearchFeeOneToFourteen : editValues.isSearchFeeOneToFourteen ;
       let isSearchFeeOneToTwenty = data.isSearchFeeOneToTwenty ? data.isSearchFeeOneToTwenty : editValues.isSearchFeeOneToTwenty ;
       let isSearchFeeOneToTwentyFive = data.isSearchFeeOneToTwentyFive ? data.isSearchFeeOneToTwentyFive : editValues.isSearchFeeOneToTwentyFive ;
       let oneThroughTwenty = data.oneThroughTwenty ? data.oneThroughTwenty : editValues.oneThroughTwenty ;
       let oneThroughTen = data.oneThroughTen ? data.oneThroughTen : editValues.oneThroughTen ;
       let oneThroughTwentyFive = data.oneThroughTwentyFive ? data.oneThroughTwentyFive : editValues.oneThroughTwentyFive ;
       let oneThroughThirty = data.oneThroughThirty ? data.oneThroughThirty : editValues.oneThroughThirty ;
       let oneThroughFourty = data.oneThroughFourty ? data.oneThroughFourty : editValues.oneThroughFourty ;
       let oneThroughHundred = data.oneThroughHundred ? data.oneThroughHundred : editValues.oneThroughHundred ;
       let sixAndOver = data.sixAndOver ? data.sixAndOver : editValues.sixAndOver ;
       let elevenAndOver = data.elevenAndOver ? data.elevenAndOver : editValues.elevenAndOver ;
       let elevenThroughTwenty = data.elevenThroughTwenty ? data.elevenThroughTwenty : editValues.elevenThroughTwenty ;
       let elevenThroughFourty = data.elevenThroughFourty ? data.elevenThroughFourty : editValues.elevenThroughFourty ;
       let elevenThroughFifty = data.elevenThroughFifty ? data.elevenThroughFifty : editValues.elevenThroughFifty ;
       let fourteenThroughTwentyFive = data.fourteenThroughTwentyFive ? data.fourteenThroughTwentyFive : editValues.fourteenThroughTwentyFive ;
       let sixteenAndOver = data.sixteenAndOver ? data.sixteenAndOver : editValues.sixteenAndOver ;
       let twentyOneThroughFifty = data.twentyOneThroughFifty ? data.twentyOneThroughFifty : editValues.twentyOneThroughFifty ;
       let twentyOneThroughSixty = data.twentyOneThroughSixty ? data.twentyOneThroughSixty : editValues.twentyOneThroughSixty ;
       let twentyOneThroughHundred = data.twentyOneThroughHundred ? data.twentyOneThroughHundred : editValues.twentyOneThroughHundred ;
       let twentySixThroughFifty = data.twentySixThroughFifty ? data.twentySixThroughFifty : editValues.twentySixThroughFifty ;
       let twentySixThroughHundred = data.twentySixThroughHundred ? data.twentySixThroughHundred : editValues.twentySixThroughHundred ;
       let twentySixThroughThreeFifty = data.twentySixThroughThreeFifty ? data.twentySixThroughThreeFifty : editValues.twentySixThroughThreeFifty ;
       let twentySixAndOver = data.twentySixAndOver ? data.twentySixAndOver : editValues.twentySixAndOver ;
       let thirtyOneAndOver = data.thirtyOneAndOver ? data.thirtyOneAndOver : editValues.thirtyOneAndOver ;
       let fourtyOneAndOver = data.fourtyOneAndOver ? data.fourtyOneAndOver : editValues.fourtyOneAndOver ;
       let fiftyOneThroughHundred = data.fiftyOneThroughHundred ? data.fiftyOneThroughHundred : editValues.fiftyOneThroughHundred ;
       let fiftyOneAndOver = data.fiftyOneAndOver ? data.fiftyOneAndOver : editValues.fiftyOneAndOver ;
       let sixtyOneAndOver = data.sixtyOneAndOver ? data.sixtyOneAndOver : editValues.sixtyOneAndOver ;
       let hundredAndOneAndOver = data.hundredAndOneAndOver ? data.hundredAndOneAndOver : editValues.hundredAndOneAndOver ;
       let threeFiftyOneAndOver = data.threeFiftyOneAndOver ? data.threeFiftyOneAndOver : editValues.threeFiftyOneAndOver ;
       let regardlessOfAllPages = data.regardlessOfAllPages ? data.regardlessOfAllPages : editValues.regardlessOfAllPages ;


            this.setState({
                  access_token,
                  id, 
                  state,
                  stateAbbreviation,
                  isAllowedState,
                  isPostageUpchargeAllowed,
                  upChargeRate,
                  isFedexOrMailAvailable,
                  searchOrHandlingFee,
                  isSearchFeeToPatientAsRequestor,
                  maximumFee,
                  isSearchFeeOneToFive,
                  isSearchFeeOneToTen,
                  isSearchFeeOneToFourteen,
                  isSearchFeeOneToTwenty,
                  isSearchFeeOneToTwentyFive,
                  oneThroughTwenty,
                  oneThroughTen,
                  oneThroughTwentyFive,
                  oneThroughThirty,
                  oneThroughFourty,
                  oneThroughHundred,
                  sixAndOver,
                  elevenAndOver,
                  elevenThroughTwenty,
                  elevenThroughFourty,
                  elevenThroughFifty,
                  fourteenThroughTwentyFive,
                  sixteenAndOver,
                  twentyOneThroughFifty,
                  twentyOneThroughSixty,
                  twentyOneThroughHundred,
                  twentySixThroughFifty,
                  twentySixThroughHundred,
                  twentySixThroughThreeFifty,
                  twentySixAndOver,
                  thirtyOneAndOver,
                  fourtyOneAndOver,
                  fiftyOneThroughHundred,
                  fiftyOneAndOver,
                  sixtyOneAndOver,
                  hundredAndOneAndOver,
                  threeFiftyOneAndOver,
                  regardlessOfAllPages 
            })

       }

       
    }

    openPop = () => {
      document.body.classList.add('modal-open');
      this.setState({
          openPopUp: true,
         
      
      })
  }
  closePop = () => {
      document.body.classList.remove('modal-open');
      this.setState({
          openPopUp: false
      })
  }

updatePaymentRules = (e) =>{
      e.preventDefault();
      const {
            email,
            access_token,
            id, 
            state,
            stateAbbreviation,
            isAllowedState,
            isPostageUpchargeAllowed,
            upChargeRate,
            isFedexOrMailAvailable,
            searchOrHandlingFee,
            isSearchFeeToPatientAsRequestor,
            maximumFee,
            isSearchFeeOneToFive,
            isSearchFeeOneToTen,
            isSearchFeeOneToFourteen,
            isSearchFeeOneToTwenty,
            isSearchFeeOneToTwentyFive,
            oneThroughTwenty,
            oneThroughTen,
            oneThroughTwentyFive,
            oneThroughThirty,
            oneThroughFourty,
            oneThroughHundred,
            sixAndOver,
            elevenAndOver,
            elevenThroughTwenty,
            elevenThroughFourty,
            elevenThroughFifty,
            fourteenThroughTwentyFive,
            sixteenAndOver,
            twentyOneThroughFifty,
            twentyOneThroughSixty,
            twentyOneThroughHundred,
            twentySixThroughFifty,
            twentySixThroughHundred,
            twentySixThroughThreeFifty,
            twentySixAndOver,
            thirtyOneAndOver,
            fourtyOneAndOver,
            fiftyOneThroughHundred,
            fiftyOneAndOver,
            sixtyOneAndOver,
            hundredAndOneAndOver,
            threeFiftyOneAndOver,
            regardlessOfAllPages 
      } = this.state

      let Payload = {
            email,
            id, 
            state,
            stateAbbreviation,
            isAllowedState,
            isPostageUpchargeAllowed,
            upChargeRate,
            isFedexOrMailAvailable,
            searchOrHandlingFee,
            isSearchFeeToPatientAsRequestor,
            maximumFee,
            isSearchFeeOneToFive,
            isSearchFeeOneToTen,
            isSearchFeeOneToFourteen,
            isSearchFeeOneToTwenty,
            isSearchFeeOneToTwentyFive,
            oneThroughTwenty,
            oneThroughTen,
            oneThroughTwentyFive,
            oneThroughThirty,
            oneThroughFourty,
            oneThroughHundred,
            sixAndOver,
            elevenAndOver,
            elevenThroughTwenty,
            elevenThroughFourty,
            elevenThroughFifty,
            fourteenThroughTwentyFive,
            sixteenAndOver,
            twentyOneThroughFifty,
            twentyOneThroughSixty,
            twentyOneThroughHundred,
            twentySixThroughFifty,
            twentySixThroughHundred,
            twentySixThroughThreeFifty,
            twentySixAndOver,
            thirtyOneAndOver,
            fourtyOneAndOver,
            fiftyOneThroughHundred,
            fiftyOneAndOver,
            sixtyOneAndOver,
            hundredAndOneAndOver,
            threeFiftyOneAndOver,
            regardlessOfAllPages 
      }
      document.body.classList.remove('modal-open');

      this.setState({
            openPopUp: false
        })
     
            this.props.editPaymentRule(access_token, Payload, );

}


componentWillReceiveProps = nextProps =>{
      if(nextProps.editPaymentRuleStatus){
           this.props.history.push("/PaymentRules")
      }
}


    handleChange = (e) => {
      e.preventDefault();
      const name = e.target.name;
      const value = e.target.value;

      this.setState({ [name]: value });
    };

    goBack = (e) =>{
          e.preventDefault();
          this.props.history.push("/PaymentRules")
    }



    render(){
      const {
           
            state,
            stateAbbreviation,
            isAllowedState,
            isPostageUpchargeAllowed,
            upChargeRate,
            isFedexOrMailAvailable,
            searchOrHandlingFee,
            isSearchFeeToPatientAsRequestor,
            maximumFee,	
            isSearchFeeOneToFive,
            isSearchFeeOneToTen,
            isSearchFeeOneToFourteen,
            isSearchFeeOneToTwenty,
            isSearchFeeOneToTwentyFive,
            oneThroughTwenty,
            oneThroughTen,
            oneThroughTwentyFive,
            oneThroughThirty,
            oneThroughFourty,
            oneThroughHundred,
            sixAndOver,
            elevenAndOver,
            elevenThroughTwenty,
            elevenThroughFourty,
            elevenThroughFifty,
            fourteenThroughTwentyFive,
            sixteenAndOver,
            twentyOneThroughFifty,
            twentyOneThroughSixty,
            twentyOneThroughHundred,
            twentySixThroughFifty,
            twentySixThroughHundred,
            twentySixThroughThreeFifty,
            twentySixAndOver,
            thirtyOneAndOver,
            fourtyOneAndOver,
            fiftyOneThroughHundred,
            fiftyOneAndOver,
            sixtyOneAndOver,
            hundredAndOneAndOver,
            threeFiftyOneAndOver,
            regardlessOfAllPages,
        } = this.state;

        return(

<React.Fragment>
    <Header status={"afterLogin"}   />
            
<div className="content"> 
   <div className="contentSection" id="content">
      <div className="container-fluid">
         <div className="titleContent">
            <ul className="breadcrumb">
               <li><a href="#">Employee</a></li>
               <li><a href="#">Admin</a></li>
               <li className="active"><a href="#">Edit-Payment Rules</a></li>
            </ul>
 
         </div>
         <div className="bodyContent">
            <div className="row">
               <div className="col-lg-8 col-md-8 col-xs-12">
                  <div className="payment_details">
                     <p>Please ensure that each state as appropriate rates as per regulations</p>
                  </div>
               </div>
               <div className="col-lg-4 col-6 col-xs-12">
                  <div className="payment_details_last_updated">
                     <p>Last updated : <span>Aug 31 2018</span> </p>
                  </div>
               </div>
            </div>
            <div className="row">
               <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>State</label>
                              <input type="text" onChange={this.handleChange}
                                 name="state" value={state} placeholder="State" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>State Abbreviation</label>
                              <input type="text" onChange={this.handleChange}
                                name="stateAbbreviation" value={stateAbbreviation} placeholder="State Abbreviation" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Allowed state on epaper road</label>
                              <input type="text" onChange={this.handleChange}
                                name="isAllowedState" value={isAllowedState} placeholder="Allowed state on epaper road" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Postage upcharge allowed?</label>
                              <input type="text" onChange={this.handleChange}
                                 name="isPostageUpchargeAllowed" value={isPostageUpchargeAllowed} placeholder="Postage upcharge allowed?" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Upcharge rate</label>
                              <input type="text" onChange={this.handleChange}
                               name="upChargeRate" value={upChargeRate} placeholder="Upcharge rate" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Fedex / Mail Available</label>
                              <input type="text" onChange={this.handleChange}
                               name="isFedexOrMailAvailable" value={isFedexOrMailAvailable} placeholder="Fedex / Mail Available" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Search/ Handling  Fee</label>
                              <input type="text" onChange={this.handleChange}
                                name="searchOrHandlingFee" value={searchOrHandlingFee} placeholder="Search/ Handling  Fee" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Search Fee Applies to Patient as Requestor</label>
                              <input type="text" onChange={this.handleChange}
                                name="isSearchFeeToPatientAsRequestor" value={isSearchFeeToPatientAsRequestor} placeholder="Search Fee Applies to Patient as Requestor" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Maximum Fee (not including postage)</label>
                              <input type="text" onChange={this.handleChange}
                                name="maximumFee" value={maximumFee} placeholder="Maximum Fee (not including postage)" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>search fee includes 1-5</label>
                              <input type="text" onChange={this.handleChange}
                                name="isSearchFeeOneToFive" value={isSearchFeeOneToFive} placeholder="search fee includes 1-5" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>search fee includes 1-10</label>
                              <input type="text" onChange={this.handleChange}
                                name="isSearchFeeOneToTen" value={isSearchFeeOneToTen} placeholder="search fee includes 1-10" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>search fee includes 1-14</label>
                              <input type="text" onChange={this.handleChange}
                                name="isSearchFeeOneToFourteen" value={isSearchFeeOneToFourteen} placeholder="search fee includes 1-14" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>search fee includes 1-20</label>
                              <input type="text" onChange={this.handleChange}
                                name="isSearchFeeOneToTwenty" value={isSearchFeeOneToTwenty} placeholder="search fee includes 1-20" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>search fee includes 1-25</label>
                              <input type="text" onChange={this.handleChange}
                                name="isSearchFeeOneToTwentyFive" value={isSearchFeeOneToTwentyFive} placeholder="search fee includes 1-25" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>1 through 20</label>
                              <input type="text" onChange={this.handleChange}
                                name="oneThroughTwenty" value={oneThroughTwenty} placeholder="1 through 20" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>1 through 10</label>
                              <input type="text" onChange={this.handleChange}
                                name="oneThroughTen" value={oneThroughTen} placeholder="1 through 10" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>1 through 25</label>
                              <input type="text" onChange={this.handleChange}
                                name="oneThroughTwentyFive" value={oneThroughTwentyFive} placeholder="1 through 25" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>1 through 30</label>
                              <input type="text" onChange={this.handleChange}
                                name="oneThroughThirty" value={oneThroughThirty} placeholder="1 through 30" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>1 through 40</label>
                              <input type="text" onChange={this.handleChange}
                                name="oneThroughFourty" value={oneThroughFourty} placeholder="1 through 40" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>1 through 100</label>
                              <input type="text" onChange={this.handleChange}
                                name="oneThroughHundred" value={oneThroughHundred} placeholder="1 through 100" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>6 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="sixAndOver" value={sixAndOver} placeholder="6 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>11 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="elevenAndOver" value={elevenAndOver} placeholder="11 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>11 through 20</label>
                              <input type="text" onChange={this.handleChange}
                                name="elevenThroughTwenty" value={elevenThroughTwenty} placeholder="11 through 20" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>11 through 40</label>
                              <input type="text" onChange={this.handleChange}
                                name="elevenThroughFourty" value={elevenThroughFourty} placeholder="11 through 40" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>11 through 50</label>
                              <input type="text" onChange={this.handleChange}
                                name="elevenThroughFifty" value={elevenThroughFifty} placeholder="11 through 50" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>14 through 25</label>
                              <input type="text" onChange={this.handleChange}
                                name="fourteenThroughTwentyFive" value={fourteenThroughTwentyFive} placeholder="14 through 25" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>16and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="sixteenAndOver" value={sixteenAndOver} placeholder="16and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>21 through 50</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentyOneThroughFifty" value={twentyOneThroughFifty} placeholder="21 through 50" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>21 through 60</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentyOneThroughSixty" value={twentyOneThroughSixty} placeholder="21 through 60" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>21 through 100</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentyOneThroughHundred" value={twentyOneThroughHundred} placeholder="21 through 100" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>26 through 50</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentySixThroughFifty" value={twentySixThroughFifty} placeholder="26 through 50" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>26 through 100</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentySixThroughHundred" value={twentySixThroughHundred} placeholder="26 through 100" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>26 through 350</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentySixThroughThreeFifty" value={twentySixThroughThreeFifty} placeholder="26 through 350" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>26 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="twentySixAndOver" value={twentySixAndOver} placeholder="26 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>31 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="thirtyOneAndOver" value={thirtyOneAndOver} placeholder="31 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>41 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="fourtyOneAndOver" value={fourtyOneAndOver} placeholder="41 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>51 through 100</label>
                              <input type="text" onChange={this.handleChange}
                                name="fiftyOneThroughHundred" value={fiftyOneThroughHundred} placeholder="51 through 100" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>51 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="fiftyOneAndOver" value={fiftyOneAndOver} placeholder="51 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>61 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="sixtyOneAndOver" value={sixtyOneAndOver} placeholder="61 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>101 and over</label>
                              <input type="text" onChange={this.handleChange}
                                name="hundredAndOneAndOver" value={hundredAndOneAndOver} placeholder="101 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>351 and over</label>
                              <input type="text" onChange={this.handleChange}
                               name="threeFiftyOneAndOver" value={threeFiftyOneAndOver} placeholder="351 and over" className="form-control"/>
                          </div>
                  </div>
                  <div className="col-lg-4 col-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                              <label>Regardless of the # of pages</label>
                              <input type="text" onChange={this.handleChange}
                                name="regardlessOfAllPages" value={regardlessOfAllPages} placeholder="Regardless of the # of pages" className="form-control"/>
                          </div>
                  </div>
                     
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                  <a href="#" onClick={this.goBack}><button type="button" className="btnDefault">Go Back</button></a>
                   <button type="button" onClick={this.openPop} className="btnDefault"><i/>Update Rules
                  </button>
               </div>
               </div>
            </div>
         </div>
      </div>
   </div></div>
   <DeleteModel header = "Edit" text="Are you sure you want to edit?" page="editPaymentRules" status={this.state.openPopUp} confirmOkay={this.updatePaymentRules}  closePop={this.closePop}/>

            <Footer />
   </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
      savedPaymentRule: state.adminReducer.savedPaymentRule,
      editPaymentRuleStatus : state.adminReducer.editPaymentRuleStatus,
      loginDetails: state.commonReducer.loginDetails,
      profileDetails: state.commonReducer.profileDetails 
   });
   const mapDispatchToProps = dispatch => ({
      editPaymentRule: ( token,payload) => dispatch(editPaymentRule(token,payload)),
    
   
   });
   
   export default connect(
      mapStateToProps,
      mapDispatchToProps
   )(EditPaymentRules);

